<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<h2 class="ah" id="ahabbrs01"><a class="page" id="px"></a><a class="page" id="pxi"></a>Conventions</h2>
<p class="paft"><a class="page" data-locator="pxi"></a>All dates are given in the old style, except that the year is taken as beginning on 1 January. All quotations are in their original spelling with i/j and u/v modernized and superscripts lowered. Common contractions such as “ye,” “yt,” “wch,” and “wt” have been expanded to “the,” “it,” “which,” and “with.” The place of publication for all works printed before 1900 is London unless otherwise stated.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chi-Leong-0008.vue?3eb2b224